export default "__VITE_ASSET__ZR$1H0LJ__"